module.exports = __webpack_public_path__ + "media/images/emblems/Hilterfingen-coat_of_arms-14e8c1e77da052fe55fbbd47e0feda89.svg";